const state = {
  dialog: false,
};

const getters = {
  getDialog: (state) => state.dialog,
};

const actions = {
  toggleDialog({ commit }) {
    commit('toggleDialog');
  },
};

const mutations = {
  toggleDialog($state) {
    const stateCopy = $state;
    stateCopy.dialog = !stateCopy.dialog;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
